import Create from "./Create";
import Edit from "./Edit";
import List from "./List";

const routes = [
    {
        path: 'warehouses',
        element: <List />
    },
    {
        path: 'warehouses/create',
        element: <Create />
    },
    {
        path: 'warehouses/edit/:id',
        element: <Edit />
    }
]
export default routes;